import styled from 'styled-components'

import { Cell } from 'components/Lists'

export const SpinnerCell = styled(Cell)`
	align-self: flex-start;
	margin-top: 6px;
`
